define('components/PatientFilter/PatientFilterComponent',[
	'core/can',
	'models/Patient',
	'text!components/PatientFilter/PatientFilterView.stache',
	'bloodhound',
	'typeahead'
], function(can, Patient, template, Bloodhound) {
	
	var Patients = Patient.Name.List.extend({
		
		isTooLarge: can.compute(function() {
			return this.attr('length') > 50;
		}),
		
		initTypeahead: function(scope, el) {
			
			var engine = new Bloodhound({
				datumTokenizer: Bloodhound.tokenizers.obj.whitespace('FirstName', 'LastName'),
				queryTokenizer: Bloodhound.tokenizers.whitespace,
				local: this.attr(),
				limit: 10
			});
			
			engine.initialize().done(function() {
				el.find('input').typeahead({ 
					highlight: true,
					hint: false
				},{
					displayKey: function(datum) {
						return datum.LastName + ', ' + datum.FirstName 
					},
					source: engine.ttAdapter()
				});
			});
		}
	});
	
	can.Component.extend({
		
		tag: 'ax-patients',
		
		template: template,
		
		scope: function(attrs, parentScope, element) {

			var scope = new can.Map({ 
				isLoading: true,
				Patients: new Patients
			});
			
			var params = {};
			if (attrs.providerid)
				params.ProviderId = attrs.providerid;
			
			Patient.Name.findAll(params, function(patients) {
				scope.attr('Patients').attr(patients.attr());
				scope.attr('isLoading', false);
			});
			
			return scope;
		},
		
		events: {
			
			'select change': function(el, ev) {
				this.element.trigger('patient:selected', {
					id: el.val()
				});
				
			},
			
			'typeahead:selected': function(el, ev, datum, dataset) {
				this.element.trigger('patient:selected', {
					id: datum.EntityId
				});
			},
			
			'reset': function() {
				if (this.scope.attr('Patients.isTooLarge')) {
					this.element.find('.tt-input').typeahead('val', '');
				} else {
					this.element.find('select').val('');
				}
			}
		}
	});
	
});
